import BookingLanding from './BookingLanding';

export default BookingLanding;
